/** Traduz erros comuns do Supabase/GoTrue para mensagens exibíveis no app. */
export function describeAuthError(error: unknown): string {
  if (!(error instanceof Error)) return "Não foi possível concluir a operação. Tente novamente.";

  const message = error.message.trim();
  const normalized = message.toLowerCase();

  if (normalized.includes("invalid login credentials")) return "E-mail ou senha inválidos.";
  if (normalized.includes("email not confirmed")) return "Confirme seu e-mail antes de entrar.";
  if (normalized.includes("user already registered")) return "Já existe uma conta com este e-mail.";
  if (normalized.includes("password should be at least")) return "A senha é muito curta.";
  if (normalized.includes("new password should be different")) return "A nova senha precisa ser diferente da atual.";
  if (normalized.includes("for security purposes")) return "Muitas tentativas. Aguarde alguns instantes e tente novamente.";
  if (normalized.includes("unable to validate email address")) return "E-mail inválido.";
  if (normalized.includes("email rate limit exceeded")) return "Limite de e-mails atingido. Tente novamente mais tarde.";
  if (normalized.includes("auth session missing")) return "Sessão expirada. Entre novamente.";
  if (normalized.includes("failed to fetch") || normalized.includes("network")) return "Falha de conexão. Verifique sua internet.";

  return message || "Não foi possível concluir a operação. Tente novamente.";
}
